<template>
  <div>
    <div v-if="loading" class="loading-screen">
      <div class="spinner" />
      <p>Loading assessment...</p>
    </div>
    <LandingPage v-else-if="quiz" :quiz="quiz" />
    <div v-else class="loading-screen">
      <p>Assessment not found.</p>
      <router-link to="/">Back to Home</router-link>
    </div>
  </div>
</template>

<script>
import LandingPage from '../components/LandingPage.vue'
import { getQuiz } from '../api'
import { quizStore } from '../store/quiz'

export default {
  name: 'QuizLandingView',
  components: { LandingPage },
  props: { id: { type: [String, Number], required: true } },
  data () {
    return { loading: true, quiz: null }
  },
  created () {
    this.fetchQuiz()
  },
  watch: {
    id () { this.fetchQuiz() }
  },
  methods: {
    async fetchQuiz () {
      this.loading = true
      try {
        const data = await getQuiz(this.id)
        quizStore.setQuizPayload(Number(this.id), data.quiz, data.questions)
        this.quiz = data.quiz
      } catch (e) {
        this.quiz = null
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
